import Error404 from "../../Components/Pages/Error404";

export const routes = [
    {
        path: '/404',
        name: '404',
        component: Error404,
        meta: {
            title: 'Page not found'
        }
    },
    {
        path: '*',
        redirect: '/404',
    }
]
